// 公開ページ用の API・リンク・メディア URL の解決。
// 以前は /preview（公開前データの確認）でベースを切り替えていたが、プレビュー機能は廃止した
// （管理画面で保存した内容がそのまま公開される）。関数名は呼び出し側との互換のために残している。

/** 公開 API のベース URL */
export function getApiBase(): string {
  return "/api/public";
}

/** ナビゲーション/Link 用のパスプレフィックス（プレビュー廃止により常に空） */
export function getPathPrefix(): string {
  return "";
}

/**
 * Cloudflare R2 の公開 CDN ベース URL（ビルド時に VITE_CLOUDFLARE_R2_CDN_PUBLIC_URL で注入）。
 * 例: "https://cdn.miyako.example"  (末尾スラッシュは付けない / 付いていても自動で取り除く)
 * 未設定なら従来通りオリジン (nginx → /app/static → Go fallback) から配信。
 */
const R2_CDN_BASE: string = (import.meta.env.VITE_CLOUDFLARE_R2_CDN_PUBLIC_URL || "")
  .toString()
  .replace(/\/+$/, "");

/**
 * `/static/...` を Cloudflare R2 CDN の絶対 URL に書き換える。
 * R2 上のキーは production だと `static/...` でホストされており、CDN ベース URL の直下に
 * 同じパスで公開されている前提（独自ドメイン or *.r2.dev 共通）。
 *  - CDN 未設定なら入力をそのまま返す（オリジンから配信）。
 */
function toCdnIfStatic(path: string): string {
  if (!R2_CDN_BASE) return path;
  if (!path.startsWith("/static/")) return path;
  return R2_CDN_BASE + path;
}

/**
 * エンティティに保存された storage_path を実際の URL に解決する。
 * - 絶対URL(http(s)://) はそのまま
 * - `/static/...` は Cloudflare R2 CDN へリダイレクト（VITE_CLOUDFLARE_R2_CDN_PUBLIC_URL が設定されているとき）
 * - `/api/...` はそのまま
 * - それ以外は `/api/public/media/<path>` 経由でローカルキャッシュ/R2 から取得
 */
export function resolveMediaUrl(storagePath: string | null | undefined): string {
  if (!storagePath) return "";
  if (/^https?:\/\//i.test(storagePath)) return storagePath;
  if (storagePath.startsWith("/static/")) {
    return toCdnIfStatic(storagePath);
  }
  if (storagePath.startsWith("/api/")) {
    return storagePath;
  }
  return `/api/public/media/${storagePath}`;
}

/** 公開ページの fetch */
export function authFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  return fetch(input, { credentials: "same-origin", ...init });
}
